import {Pipe, PipeTransform} from '@angular/core';
import {environment} from '../../../environments/environment';
import { orderBy } from 'lodash';

@Pipe({
  name: 'concatProperties',
})
export class ConcatPropertiesPipe implements PipeTransform {

  /**
   * Concatena una propiedad de un arreglo de objetos
   * @param data object[]
   * @param property propiedad del arreglo de objetos a trabajar
   * @param maxItems Número máximo de elemenos a concatenar
   * @param subfix texto que pondra al final de la concatenacion de propiedades
   * @return string
   *
   * ex:
   * const participants = [
   *    {name: 'Francisco Villa', ...},
   *    {name: 'Mario Pérez', ...},
   *    {name: 'Juan Pérez', ...},
   *    {name: 'Mauricio Pérez', ...},
   * ];
   * transform(participants, 'name', 3)
   * return 'Francisco Villa, Mario Pérez, Juan Pérez y 1 participante(s) más';
   */
  transform(data: object[], property = 'name', maxItems = 2): string {
    const size = data.length;

    if (size === 0) {
      if (!environment.production) { console.warn('[getNameParticipants] not data'); }
      return '';
    }

    if (!maxItems || maxItems > size) {
      maxItems = size;
    }
    if (typeof data[0][property] === 'string') {
      data = orderBy(data, [(item) => item[property].length, property], ['asc']);
    }
    return data.reduce<string>((acc: string, next: object, index: number, array: object[]) => {
      if (index < maxItems) {
        return acc += ((property !== 'none' ? next[property] : next) + (index + 1 === maxItems ? ''  :  (array[index + 2] ? ', ' : ' y ')));
      }
      return acc;
    }, '');
  }


}
